import AuthGuard, { AuthFlow } from '@components/AuthGuard';
import Button from '@components/Button';
import Row from '@components/Row';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ItemResponse } from '@models/item';
import { Link } from '@stackflow/link';
import { useItemActivityId } from '@store/item/context/ItemActivityContext';
import { useTranslation } from 'react-i18next';

import useAddCart from './hooks/useAddCart';
import OptionSelectionGuard from './OptionSelectionGuard';

interface Props {
    shopId: string;
    isSoldOut: boolean;
    item: ItemResponse;
}

function OrderRow({ shopId, isSoldOut, item }:Props) {
    const { t } = useTranslation('item');
    const itemId = item.id;
    const activityId = useItemActivityId();
    const { handleAddToCart } = useAddCart(shopId);
    const authFlows: AuthFlow[] = [
        { activityName: 'ShopListActivity', activityParams: { isOrder: false, type: 'LIST' } },
        { activityName: 'ItemsActivity', activityParams: { shopId, type: 'ALL' } },
        { activityName: 'ItemActivity', activityParams: { itemId, shopId } },
    ];
    return (
        <Container spacing={16} >
            <Row fullWidth spacing={8}>
                <AuthGuard flows={authFlows}>
                    <OptionSelectionGuard item={item}>
                        <Button fullWidth variant='secondary'
                            onClick={handleAddToCart}
                            noPadding>
                            {t('footer.addToCart')}
                        </Button>
                    </OptionSelectionGuard>
                </AuthGuard>
                <AuthGuard flows={authFlows}>
                    <OptionSelectionGuard item={item}>
                        <Link activityName='OrderActivity'
                            activityParams={{ path: 'direct', itemActivityId: activityId }}
                            css={css`width: 100%`} >
                            <Button fullWidth
                                disabled={isSoldOut}
                                noPadding>
                                {isSoldOut ? t('footer.soldOut') : t('footer.orderNow')}
                            </Button>
                        </Link>
                    </OptionSelectionGuard>
                </AuthGuard>
            </Row>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 4px 0 0;
`;

export default OrderRow;
